import PropTypes from 'prop-types';
import { BiLoaderAlt } from 'react-icons/bi';

const FullPageLoader = ({ show }) => {
  const showClassName = show ? 'opacity-100 visible' : 'opacity-0 invisible';
  const barHeight = '5px';

  return (
    <div
      className={`fixed top-0 left-0 w-screen h-screen bg-white transition-all flex flex-col items-center justify-center z-50 ${showClassName}`}
    >
      <div className="flex flex-col items-center -mt-20">
        <div className="flex items-center gap-4">
          <BiLoaderAlt size={24} className="text-primary animate-spin" />
          <div className="text-xl">Loading...</div>
        </div>
        <div
          className="relative w-48 mt-5 overflow-hidden bg-gray-200 rounded md:w-56"
          style={{ height: barHeight }}
        >
          <div className="absolute top-0 left-0 w-20 h-full transition-all transform animate-fullpage-loading bg-primary" />
        </div>
      </div>
    </div>
  );
};

FullPageLoader.propTypes = {
  show: PropTypes.bool,
};

FullPageLoader.defaultProps = {
  show: true,
};

export default FullPageLoader;
